import { useState, useEffect } from 'react';
import { makeCall } from 'utils/utils';
import WithMotion from 'components/withMotion';
import { Grid, makeStyles } from '@material-ui/core';
import MaterialTable, { MTableToolbar } from '@material-table/core';
import { columns } from './initialData';
import { Data } from './types';
import { Update } from './Update';
import { Create } from './Create';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(6),
  },
  toolbarWrapper: {
    '& .MuiToolbar-gutters': {
      paddingLeft: '16px',
      paddingRight: 0,
    },
    '& .MuiTypography-h6': {
      color: theme.palette.primary.main,
    },
  },
}));

function ApiKeys() {
  const classes = useStyles();
  const [shouldFetch, setShouldFetch] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isCreate, setIsCreate] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [data, setData] = useState<Data[]>([]);
  const [record, setRecord] = useState<Data | null>(null);
  const [isMessage, setIsMessage] = useState(false);

  useEffect(() => {
    const getData = async () => {
      const response = await makeCall('apikeys', 'GET');
      setIsLoading(false);
      console.log(response?.data);
      setData(response?.data.data);
      setShouldFetch(false);
    };
    if (shouldFetch) {
      getData();
    }
  }, [shouldFetch]);

  const getRecord = async (clickedRow: Data) => {
    const response = await makeCall(`apikeys/${clickedRow.apiKeyUuid}`, 'GET');
    setRecord(response?.data.data);
    setIsUpdate(true);
  };

  const copy = (clickedRow: Data) => {
    navigator.clipboard.writeText(clickedRow.apiKeyPublicKey);
    setIsMessage(true);
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={isMessage}
        autoHideDuration={3000}
        onClose={() => setIsMessage(false)}
      >
        <Alert variant="filled" severity="success">
          Public key copied to clipboard!
        </Alert>
      </Snackbar>
      <Create
        open={isCreate}
        handleClose={() => setIsCreate(!isCreate)}
        refresh={() => {
          setIsLoading(true);
          setShouldFetch(true);
        }}
      />
      <Update
        record={record}
        open={isUpdate}
        handleClose={() => setIsUpdate(!isUpdate)}
        refresh={() => {
          setIsLoading(true);
          setShouldFetch(true);
        }}
      />
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <MaterialTable
            title="API keys"
            components={{
              Toolbar: (props) => (
                <div className={classes.toolbarWrapper}>
                  <MTableToolbar {...props} />
                </div>
              ),
            }}
            options={{
              search: true,
              pageSize: 10,
              actionsColumnIndex: 6,
              actionsCellStyle: { color: '#666' },
            }}
            actions={[
              {
                icon: 'add',
                tooltip: 'Create API key',
                isFreeAction: true,
                onClick: () => setIsCreate(!isCreate),
              },
              {
                icon: 'assignment',
                tooltip: 'Copy public key',
                isFreeAction: false,
                onClick: (event, rowData: any) => copy(rowData),
              },
              {
                icon: 'edit',
                tooltip: 'Update API key',
                isFreeAction: false,
                onClick: (event, rowData: any) => getRecord(rowData),
              },
            ]}
            isLoading={isLoading}
            columns={columns}
            data={data}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default WithMotion(ApiKeys);
